/* eslint-disable no-shadow */
import React from 'react';

import { useMutation } from '@tanstack/react-query';

import { formatCurrency } from '../../../helpers/currencyMask';
import { useUiContext } from '../../../context/UiContext';
import BillPaymentBillLineItemService from '../../../services/BillPaymentBillLineItemService';

export default function Reverse({ row, refetch }) {
  const { showDialogModal, showToast } = useUiContext();

  const { mutate: reverseBillPaymentBillLineItem } = useMutation({
    mutationFn: (id) =>
      BillPaymentBillLineItemService.reverseBillPaymentBillLineItem(id),
    onSuccess: () => {
      showToast({
        text: 'Reversed',
        type: 'success',
      });
      refetch?.();
    },
    onError: (error) => {
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  if (row.description === 'Total') {
    return null;
  }

  return (
    <div className="flex gap-2">
      {row._bill_payment_bill_line_items?.map((item) => (
        <button
          type="button"
          className="btn dark:bg-slate-800 border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 text-indigo-500"
          onClick={() => {
            showDialogModal({
              title: 'Reverse',
              message: 'Are you sure you want to reverse this amount?',
              confirmButtonLabel: 'Yes, reverse it',
              cancelButtonLabel: 'No, cancel',
              onConfirm: () => reverseBillPaymentBillLineItem(item.id),
            });
          }}
        >
          Reverse ${formatCurrency(item.amount)}
        </button>
      ))}
    </div>
  );
}
